<template>
  <li class="c-tab-item">
    <button
      type="button"
      class="c-tab-item__button"
      :class="{ active: item.isSelected }"
      @click="$emit('tab-item-clicked')"
    >
      {{ item.title }}
    </button>
  </li>
</template>

<script>
export default {
  name: 'ComponentTabItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return { title: 'title' }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-tab-item {
  @include mixins.screen-desktop {
    & + & {
      margin-left: 8px;
    }
  }

  &__button {
    border-radius: 50px;
    font-size: 13px;
    font-weight: 600;
    line-height: 36px;
    padding: 0 16px;
    transition: background-color 0.3s;
    white-space: nowrap;

    @include mixins.screen-mobile {
      font-size: 12px;
      padding: 0 8px;
    }

    @include mixins.screen-desktop {
      &:hover {
        background-color: variables.$color-accent;
        color: #fff;
      }
    }

    &.active {
      background-color: variables.$color-accent;
      color: #fff;
    }
  }
}
</style>
